module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages-new/program/program-read/program-read.component.css
// module id = ./src/app/pages-new/program/program-read/program-read.component.css
// module chunks = main